import run from './src/front/loader';
import registry from './src/front/registry';

run(registry, document.currentScript);
